import {downloadComplianceDocument} from '../../api/campaign/compliance/downloadComplianceDocument';
import {generateComplianceDocument} from '../../api/campaign/compliance/generateComplianceDocument';
import {isComplianceDocumentReadyForDownload} from '../../api/campaign/compliance/isComplianceDocumentReadyForDownload';
import {delay} from '../../delay';
import {downloadAndSavePdfFile} from '../../file/downloadAndSavePdfFile';
import * as Sentry from "@sentry/vue";

export async function generateAndDownloadComplianceDocument(campaignId, open = false, shouldGenerate = true, shouldNotIgnoreOutdatedContent = true) {
  try {
    const {is_outdated, status} = await isComplianceDocumentReadyForDownload(campaignId, open);

    if (status === 'generated' && !(is_outdated && shouldNotIgnoreOutdatedContent)) {
      const {name, url} = await downloadComplianceDocument(campaignId, open);
      return downloadAndSavePdfFile(url, name);
    }

    if (shouldGenerate && (!status || (status === 'generated' && is_outdated))) {
      await generateComplianceDocument(campaignId, open);
    }

    await delay(5000);

    return generateAndDownloadComplianceDocument(campaignId, open, shouldGenerate);
  } catch (error) {
    const {data} = error.response || {};
    const {message} = data.data || {};

    if (message) {
      throw Error(message);
    } else {
      Sentry.captureException(error);
      throw Error('We had a problem downloading the document.');
    }
  }
}
